module.exports = __webpack_public_path__ + "2f35a8c7ca73674cc11ad84b6df80557.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/DE.svg
// module id = 1+jb
// module chunks = 0